export function SAVE_FILTERS(
	state,
	[search, selected_areas, selected_categories, selected_tags, selected_extensions]
) {
	state.search = search
	state.selected_areas = selected_areas
	state.selected_categories = selected_categories
	state.selected_tags = selected_tags
	state.selected_extensions = selected_extensions
}

export function SAVE_FILTERS_SEARCH(state, [search]) {
	state.search = search
}

export function SAVE_FILTERS_CATEGORY(state, [selected_categories]) {
	state.selected_categories = selected_categories
}

export function SAVE_FILTERS_TAG(state, [selected_tags]) {
	state.selected_tags = selected_tags
}

export function SAVE_LOADING(state, [loading]) {
	state.loading = loading
}
